import { useAtom } from "jotai";

import { userAtom } from "@shared/state";

export const useUser = () => {
  return useAtom(userAtom);
};
